import PropTypes from 'prop-types'
import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Text,
  HStack,
  Center,
} from '@chakra-ui/react'
import { formatRut } from '../../../../utils/formats/formats'
import { REPOSITORY } from './../../../../api/repository/Repository'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { colors } from './../../../../utils/theme/styles'
import Toast from './../../../Toast/Toast'
import {
  approveAssignmentErrorsUpper,
  denyAssignmentErrorsUpper,
} from '../../../../variables/errors'

export default function DenyEnrrollment({ isOpen, onClose, data }) {
  const {
    handleOpen,
    handleSetTitle,
    handleChangeBody,
    handleClose,
    handleChangeCustomColor,
  } = useRequestStatusContext()
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const handleCloseResponse = () => {
    handleClose(location.reload)
  }
  const handleOkStatus = ({ status, title }) => {
    handleCLoseLoading()
    handleSetTitle(title, status)
    handleChangeBody(
      <Button variant="primary" onClick={handleCloseResponse}>
        {status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
      </Button>,
    )
    handleOpen()
  }

  const handleDeny = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.accounts.noNominative
      .denyEnrollment(data.nIdEnrolamiento)
      .then((res) => {
        const haveError =
          res.data.filter((el) =>
            denyAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
          ).length > 0
        handleChangeCustomColor(colors.secondary.base)
        handleOkStatus({
          status: haveError ? 500 : 200,
          title: haveError
            ? res.data[0].sMensaje
            : 'Bolsillo rechazado con éxito',
        })
        onClose()
      })
  }

  const handleApprove = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.accounts.noNominative
      .approveEnrollment(data.nIdEnrolamiento)
      .then((res) => {
        const haveError =
          res.data.filter((el) =>
            approveAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
          ).length > 0
        handleOkStatus({
          status: haveError ? 500 : 200,
          title: haveError
            ? res.data[0].sMensaje
            : 'Bolsillo aprobado con éxito',
        })
        onClose()
      })
  }
  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay onClick={onClose} />
      <ModalContent>
        <ModalHeader bgColor="#565656" color="white">
          <Center w="100%">ACTIVACIÓN DE BOLSILLO</Center>
        </ModalHeader>
        <ModalBody>
          <VStack spacing="23px">
            <Text variant="subtitle1" fontWeight="600">
              Información de bolsollo
            </Text>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                RUT:
              </Text>

              <Text variant="body4" fontWeight="400">
                {formatRut(data?.sRutWalletSolicitante || '')?.formatValue}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Nombre:
              </Text>

              <Text variant="body4" fontWeight="400">
                {`${data?.sNombreSolicitante || ''} ${
                  data?.sApellidoPaternoSolicitante || ''
                }`}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Centro de costo:
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.CentroCosto || 'Sin Asignar'}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Sucursal:
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.Sucursal || 'Sin Asignar'}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Grupo:
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.sGrupo || 'Sin Asignar'}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Código de NN:
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.sEmpleado}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Saldo:
              </Text>
              <Text variant="body4" fontWeight="400">
                ${data?.nSaldo}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Fecha:
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.dFechaSolicitudEnrolamiento}
              </Text>
            </HStack>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Toast
              as="button"
              onClick={handleDeny}
              variant="cardManagement"
              bgColor={colors.log.error}
            >
              <Text color="white" variant="semibold" fontSize={14}>
                Rechazar
              </Text>
            </Toast>
            <Toast
              as="button"
              onClick={handleApprove}
              variant="cardManagement"
              bgColor={colors.primary.base}
            >
              <Text color="white" variant="semibold" fontSize={14}>
                Aprobar
              </Text>
            </Toast>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

DenyEnrrollment.propTypes = {
  data: PropTypes.shape({
    CentroCosto: PropTypes.string,
    Sucursal: PropTypes.string,
    dFechaSolicitudEnrolamiento: PropTypes.string,
    nIdEnrolamiento: PropTypes.number,
    nSaldo: PropTypes.string,
    sApellidoPaterno: PropTypes.string,
    sApellidoPaternoSolicitante: PropTypes.string,
    sEmpleado: PropTypes.string,
    sGrupo: PropTypes.string,
    sNombre: PropTypes.string,
    sNombreSolicitante: PropTypes.string,
    sRUT: PropTypes.string,
    sRutWalletSolicitante: PropTypes.string,
  }),
  handleConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
